import { render, staticRenderFns } from "./ChannelsTemplate.vue?vue&type=template&id=ae8876a4&scoped=true&"
import script from "./ChannelsTemplate.vue?vue&type=script&lang=js&"
export * from "./ChannelsTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ChannelsTemplate.vue?vue&type=style&index=0&id=ae8876a4&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae8876a4",
  null
  
)

export default component.exports